import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import styled from '@emotion/styled';

import CONST from '../constants';
import { ReactComponent as Logo } from '../resources/logo.svg';
import imgFooterBG from '../resources/pattern-texture.svg';
import imgFooterBrand from '../resources/footer.png';

const Footer = () => {
    /**************************************************************
     * HOOKS
     *************************************************************/

    /**************************************************************
     * CSS
     *************************************************************/

    const StyledFooter = styled.div`
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: ${CONST.FOOTER_HEIGHT.MOBILE};
        background: ${CONST.COLOR.BG};
        background-image: url(${imgFooterBG});
        z-index: 0;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            height: ${CONST.FOOTER_HEIGHT.STATIC};
        }
    `;

    const StyledContainer = styled(Container)`
        position: absolute;
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
        text-align: center;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            padding: 0 2.5vw 0 5vw;
            text-align: left;
        }
    `;

    const LogoLink = styled(NavLink)`
        display: inline-block;
        color: ${CONST.COLOR.TEXT};
        transition: all 400ms ease;
        text-align: center;
        text-decoration: none;

        &:hover {
            color: ${CONST.COLOR.THEME};

            & .icon {
                color: ${CONST.COLOR.LOGO.NUMBER_DARKER_30};
            }
        }

        & .icon {
            color: ${CONST.COLOR.LOGO.NUMBER};
            transition: all 300ms ease;
        }

        & > p:first-of-type {
            margin-top: 2vw;
            font-size: 7vw;

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                margin-top: 0.5vw;
                font-size: 2vw;
            }
        }
        & > p {
            margin: 0;
            font-size: 4vw;
            font-weight: bold;

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                font-size: 1.25vw;
            }
        }

        & > p > span {
            color: #979898;
        }
    `;

    const StyledLogo = styled(Logo)`
        height: 20vw;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            height: 6vw;
        }
    `;

    const LinkContainer = styled.div`
        position: relative;
        margin: 8vw 0 8vw;

        @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
            margin: 2vw 0 1vw;
        }

        & > a {
            display: table;
            margin: 0 auto 3vw;
            color: ${CONST.COLOR.TEXT};
            font-size: 4vw;
            text-decoration: none;
            transition: all 400ms ease;

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                margin: 0 0 0.5vw;
                font-size: 1.25vw;
            }

            &:last-of-type {
                margin-bottom: 0;
            }

            &:hover {
                color: ${CONST.COLOR.THEMESecondary};
                text-decoration: underline;
            }
        }
    `;

    const BrandRow = styled(Row)`
        align-items: end;

        & > div {
            text-align: center;

            &:first-of-type {
                @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                    text-align: left;
                }
            }

            &:last-of-type {
                @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                    text-align: right;
                }
            }
        }

        & > div > p {
            margin: 0;
            font-size: 2vw;
            color: ${CONST.COLOR.TEXT};

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                font-size: 0.9vw;
            }
        }

        & > div > img {
            padding-top: 2vw;
            width: 75vw;
            transition: all 0.4s ease;

            @media screen and (min-width: ${CONST.SCREEN.BREAKPOINT.SM}px) {
                padding-top: 0;
                width: 30vw;
            }
        }
    `;

    /**************************************************************
     * CORE
     *************************************************************/

    return (
        <StyledFooter>
            <StyledContainer fluid>
                <LogoLink to="/">
                    <StyledLogo />
                    <p>HIGHCUBE</p>
                    <p>
                        하이큐브 <span>구로</span>
                    </p>
                </LogoLink>
                <LinkContainer>
                    <NavLink to="/overview">사업개요</NavLink>
                    <NavLink to="/analysis">입지분석</NavLink>
                    <NavLink to="/premium">프리미엄</NavLink>
                    <NavLink to="/floor-plan">층별안내</NavLink>
                </LinkContainer>
                <BrandRow className="g-0 justify-content-between">
                    <Col className="g-0" sm="auto">
                        <p>Copyright © 2022&ensp;|&ensp;하이큐브 구로&ensp;|&ensp;서울시 영등포 당산동3가 550 1층&ensp;|&ensp;{CONST.PHONE}&ensp;|&ensp;kg1630kg@naver.com</p>
                    </Col>
                    <Col className="g-0" sm="auto">
                        <img src={imgFooterBrand} alt="" />
                    </Col>
                </BrandRow>
            </StyledContainer>
        </StyledFooter>
    );
};

export default Footer;
